import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'wilson-card-default',
  templateUrl: './card-default.component.html',
  styleUrls: ['./card-default.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CardDefaultComponent {
  @Input() cardHeader: string;
  @Input() cardDetail: string;
}
